import React, { useEffect, useState } from "react";
import * as Yup from "yup";
import { ErrorMessage, Formik } from "formik";
import {
  Button,
  Label,
  TextArea,
  Textinput,
  Modal,
  Dropdown,
} from "components";
import { icons } from "utils/constants";
import { useDispatch, useSelector } from "react-redux";
import { addFeedback, showSuccess, attachToFeedback } from "store/globalSlice";
import "./Feedback.scss";

const typeOptions = [
  { id: "Feedback", label: "Feedback" },
  { id: "Bug", label: "Bug" },
];

const Feedback = () => {
  const dispatch = useDispatch();
  const reduxData = useSelector((state) => state.global);
  const { isDarkMode } = reduxData || {};
  const [isFeeback, setIsFeeback] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);

  const handleSubmit = async (values) => {
    setBtnLoading(true);
    const { title, description, tags, images } = values;
    const payload = {
      name: title,
      description: description,
      tags: [tags],
    };
    const response = await dispatch(addFeedback(payload));
    if (response?.status === 200) {
      const taskID = response?.data?.id;
      if (images.length > 0) {
        images.forEach(async (e, i) => {
          const formData = new FormData();
          formData.append("attachment", e);
          const res = await dispatch(attachToFeedback(taskID, formData));
          if (res?.status === 200 && images.length - 1 === i) {
            dispatch(showSuccess("Feedback submit successfully."));
            setIsFeeback(false);
            setBtnLoading(false);
          }
        });
      } else {
        dispatch(showSuccess("Feedback submit successfully."));
        setIsFeeback(false);
        setBtnLoading(false);
      }
    } else {
      setBtnLoading(false);
    }
  };

  const validationSchema = Yup.object().shape({
    title: Yup.string().required("Title is required."),
    description: Yup.string().required("Description is required."),
    images: Yup.array()
      .test(
        "fileSize",
        "Picture size exceeds maximum limit 5 MB.",
        (value) =>
          !value ||
          value.length === 0 ||
          value.reduce((acc, file) => acc + file.size, 0) <= 5 * 1024 * 1024
      )
      .test(
        "maxImages",
        "Maximum 3 picture are allowed.",
        (value) => !value || value.length <= 3
      )
      .test(
        "type",
        "Invalid file selected, Accept only JPG, JPEG and PNG",
        (value) => {
          const validTypes = ["image/jpeg", "image/jpg", "image/png"];
          let isValidate = true;
          if (value.length > 0) {
            isValidate = value?.some((o) => validTypes.includes(o?.type));
          }
          return isValidate;
        }
      ),
  });

  const initialValues = {
    title: "",
    description: "",
    tags: "Feedback",
    images: [],
  };

  useEffect(() => {
    if (isFeeback) {
      setBtnLoading(false);
    }
  }, [isFeeback]);

  return (
    <div id="feedback-container">
      <div
        className="feedback-btn-block shadow"
        onClick={() => {
          setIsFeeback(true);
        }}
      >
        <img src={icons.feedback} alt="feedback" className="fit-image" />
      </div>
      {isFeeback && (
        <Modal
          title="Submit the Bug Report"
          width="650px"
          onHide={() => {
            setIsFeeback(false);
          }}
          isDarkMode={isDarkMode}
        >
          <Formik
            initialValues={initialValues}
            onSubmit={handleSubmit}
            validationSchema={validationSchema}
          >
            {(props) => {
              const {
                values,
                handleChange,
                handleSubmit,
                setFieldValue,
                handleBlur,
              } = props;
              const { title, tags, description, images } = values;

              return (
                <form
                  id={`${isDarkMode ? "dark-form" : "feedback-form-container"}`}
                  className={`row cps-26 cpe-26 cpt-26`}
                  onSubmit={handleSubmit}
                >
                  <div className="cmb-24">
                    <div className="input_select">
                      <Textinput
                        id="name"
                        label="Title"
                        value={title}
                        name="title"
                        placeholder="Enter title"
                        onChange={handleChange}
                        isDarkMode={isDarkMode}
                      // maxLength="68"
                      />
                      <Dropdown
                        id="tags"
                        options={typeOptions}
                        value={tags}
                        onChange={handleChange}
                        isDarkMode={isDarkMode}
                      />
                    </div>

                    <small className="is-invalid">
                      <ErrorMessage name="title" />
                    </small>
                  </div>

                  <div className="cmb-24">
                    <TextArea
                      rows={3}
                      id="description"
                      label="Description"
                      value={description}
                      name="description"
                      onChange={handleChange}
                      placeholder="Enter description"
                      isDarkMode={isDarkMode}
                    />
                    <small className="is-invalid">
                      <ErrorMessage name="description" />
                    </small>
                  </div>

                  <div className="cmb-24">
                    <Label label="Upload Picture" />
                    <div className="upload_img">
                      <img
                        src={isDarkMode ? icons.UploadLight : icons.Upload}
                        alt="upload_icon"
                        className="upload_icon"
                      />
                      <input
                        type="file"
                        name="images"
                        multiple
                        accept=".png , .jpg , .jpeg"
                        id="image-upload"
                        onBlur={handleBlur}
                        onChange={(e) => {
                          const files = Array.from(e.currentTarget.files);
                          setFieldValue("images", files);
                        }}
                      />
                      {images.length === 0 ? (
                        <span className={`text-14-400 ${isDarkMode ? "color-ffff" : "color-7e91"}`}>
                          Upload your file
                        </span>
                      ) : (
                        <span className="text-14-400">
                          {values.images.length} files Selected
                        </span>
                      )}
                    </div>
                    <small className="is-invalid">
                      <ErrorMessage name="images" />
                    </small>
                  </div>

                  <div className="d-flex justify-content-end">
                    <Button
                      btnStyle="PD"
                      onClick={handleSubmit}
                      loading={btnLoading}
                      btnText="Submit"
                      className="cps-30 cpe-30"
                    // disabled={!title}
                    />
                  </div>
                </form>
              );
            }}
          </Formik>
        </Modal>
      )}
    </div>
  );
};

export default Feedback;
